<template>
    <aside class="box-model-legend">
        <div class="box-model-legend__row">
            <figure class="box-model-legend__col box-model-legend__col--margin">
                <figcaption
                    v-for="(marginValue, index) in marginValues"
                    :key="index"
                    class="box-model-legend__section"
                >
                    <div class="box-model-legend__color" />

                    <span class="box-model-legend__label">
                        Margin {{ getSideText(index) }}:
                    </span>

                    <span class="box-model-legend__value">
                        {{ marginValue }}px
                    </span>
                </figcaption>
            </figure>

            <figure class="box-model-legend__col box-model-legend__col--padding">
                <figcaption
                    v-for="(paddingValue, index) in paddingValues"
                    :key="index"
                    class="box-model-legend__section"
                >
                    <div class="box-model-legend__color" />

                    <span class="box-model-legend__label">
                        Padding {{ getSideText(index) }}:
                    </span>

                    <span class="box-model-legend__value">
                        {{ paddingValue }}px
                    </span>
                </figcaption>
            </figure>
        </div>

        <div class="box-model-legend__row">
            <figure class="box-model-legend__col box-model-legend__col--offset">
                <figcaption class="box-model-legend__section">
                    <font-awesome-icon class="box-model-legend__icon" :icon="['fas', 'arrow-circle-up']" />

                    <span class="box-model-legend__label">
                        Top Offset:
                    </span>

                    <span class="box-model-legend__value">
                        {{ offset.y }}px
                    </span>
                </figcaption>
            </figure>

            <figure class="box-model-legend__col box-model-legend__col--offset">
                <figcaption class="box-model-legend__section">
                    <font-awesome-icon class="box-model-legend__icon" :icon="['fas', 'arrow-circle-left']" />

                    <span class="box-model-legend__label">
                        Left Offset:
                    </span>

                    <span class="box-model-legend__value">
                        {{ offset.x }}px
                    </span>
                </figcaption>
            </figure>
        </div>
    </aside>
</template>

<script>
export default {
    name: 'box-model-legend',

    props: {
        margin: {
            type: Object,
            required: true,
        },

        padding: {
            type: Object,
            required: true,
        },

        offset: {
            type: Object,
            required: true,
        },
    },

    computed: {
        marginValues() {
            return Object.values(this.margin);
        },

        paddingValues() {
            return Object.values(this.padding);
        },

        equalMarginValues() {
            return Object.values(this.margin).every(value => value === this.margin.top);
        },

        equalPaddingValues() {
            return Object.values(this.padding).every(value => value === this.padding.top);
        },
    },

    methods: {
        getSideText(index) {
            const sideText = ['Top', 'Right', 'Bottom', 'Left'];

            return sideText[index];
        },
    },
};
</script>

<style lang="scss">
.box-model-legend {
    $this: &;

    &__row {
        display: flex;
        align-items: center;
    }

    &__col {
        font-size: 13px;

        &--margin,
        &--padding {
            padding-bottom: 15px;
        }

        &--offset {
            padding-top: 15px;
            border-top: 1px solid $box-model-border-color;
        }

        &:first-of-type {
            padding-right: 25px;
            border-right: 1px solid $box-model-border-color;
        }

        &:last-of-type {
            padding-left: 25px;
        }
    }

    &__section {
        display: flex;
        align-items: center;

        &:not(:first-of-type) {
            margin-top: 5px;
        }
    }

    &__color {
        width: 10px;
        height: 10px;
        margin-right: 7px;

        #{ $this }__col--margin & {
            background-color: $box-model-margin;
        }

        #{ $this }__col--padding & {
            background-color: $box-model-padding;
        }
    }

    &__icon {
        color: slategray;
        font-size: 10px;
        margin-right: 7px;
    }

    &__label {
        margin-right: 10px;
        min-width: 105px;
        color: $box-model-text-color;
    }

    &__value {
        font-weight: 700;
    }
}
</style>
